import { api } from '@/api';
import {
  PostLoginResponse,
  PostLogoutRequest,
  PostLogoutResponse,
} from '@/api/type';

export const postLogout = async () => {
  try {
    const res = await api.post<PostLogoutResponse>(`/api/auth/logout`, null, {
      headers: {
        'X-Auth-Method': 'COOKIE',
      },
      withCredentials: true,
    });
    return res.data;
  } catch (err) {
    console.error('postLogin API error:', err);
    throw err;
  }
};
